import { defineStyleConfig, extendTheme } from '@chakra-ui/react';
import theme from './theme';
import { Theme } from './types';

export enum UserRole {
  Student = 'Student',
  Teacher = 'Teacher',
  WallWatcher = 'WallWatcher',
}

export const FONT_OPTIONS = [
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Tahoma', label: 'Tahoma' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Calibri', label: 'Calibri' },
  { value: 'Verdana', label: 'Verdana' },
];

export const themeDataObj: Record<Theme, Record<string, any>> = {
  blackWhiteTheme: extendTheme({
    colors: {
      text: {
        default: '#000',
      },
      border: {
        default: '#000',
      },
      white: '#FFF',
    },
    iframeBg: '#FFF',
    iframeColor: '#000',
    styles: {
      global: {
        body: {
          color: '#000',
        },
        '*::placeholder': {
          color: '#000',
        },
        '*, *::before, &::after': {
          borderColor: '#000',
        },
      },
    },
  }),
  blackGrayTheme: extendTheme({
    colors: {
      text: {
        default: '#000',
      },
      border: {
        default: '#000',
      },
      white: '#CBD5E0',
    },
    iframeBg: '#CBD5E0',
    iframeColor: '#000',
    styles: {
      global: {
        body: {
          color: '#000',
        },
        '*::placeholder': {
          color: '#000',
        },
        '*, *::before, &::after': {
          borderColor: '#000',
        },
      },
    },
  }),
  blueWhiteTheme: extendTheme({
    colors: {
      text: {
        default: '#4299E1',
      },
      border: {
        default: '#4299E1',
      },
      white: '#FFF',
    },
    iframeBg: '#FFF',
    iframeColor: '#4299E1',
    styles: {
      global: {
        body: {
          color: '#4299E1',
        },
        '*::placeholder': {
          color: '#4299E1',
        },
        '*, *::before, &::after': {
          borderColor: '#4299E1',
        },
      },
    },
  }),
  whiteBlackTheme: extendTheme({
    colors: {
      text: {
        default: '#FFF',
      },
      border: {
        default: '#FFF',
      },
      whiteAlpha: {
        500: '#FFFFFF',
      },
      white: '#000',
    },
    iframeBg: '#000',
    iframeColor: '#FFFFFF',
    components: {
      Button: defineStyleConfig({
        defaultProps: {
          colorScheme: 'whiteAlpha',
        },
      }),
    },
    styles: {
      global: {
        body: {
          color: '#FFF',
        },
        '*::placeholder': {
          color: '#FFF',
        },
        '*, *::before, &::after': {
          borderColor: '#FFF',
        },
      },
    },
  }),
  grayBlackTheme: extendTheme({
    colors: {
      text: {
        default: '#CBD5E0',
      },
      border: {
        default: '#CBD5E0',
      },
      whiteAlpha: {
        500: '#FFF',
      },
      white: '#000',
    },
    iframeBg: '#000',
    iframeColor: '#CBD5E0',
    components: {
      Button: defineStyleConfig({
        defaultProps: {
          colorScheme: 'whiteAlpha',
        },
      }),
    },
    styles: {
      global: {
        body: {
          color: '#CBD5E0',
        },
        '*::placeholder': {
          color: '#CBD5E0',
        },
        '*, *::before, &::after': {
          borderColor: '#CBD5E0',
        },
      },
    },
  }),
  whiteBlueTheme: extendTheme({
    colors: {
      text: {
        default: '#FFF',
      },
      border: {
        default: '#FFF',
      },
      white: '#4299E1',
    },
    iframeBg: '#4299E1',
    iframeColor: '#FFF',
    styles: {
      global: {
        body: {
          color: '#FFF',
        },
        '*::placeholder': {
          color: '#FFF',
        },
        '*, *::before, &::after': {
          borderColor: '#FFF',
        },
      },
    },
  }),
  theme,
};
